import React, { useCallback } from 'react';
import DotGrid from '@uber/base-icons/dot-grid';
import { useAtomValue, useSetAtom } from 'jotai';
import useFeatureFlag from '../../../../common/hooks/useFeatureFlag';
import ToolbarButton from '../../../../common/toolbar-button';
import { FEATURE_FLAGS } from '../../../labelling/constants';
import { toggleVideoGridAction } from '../../actions/toggle-video-grid';
import { canEnableGridViewAtom, isGridViewEnabledAtom } from '../../atoms/grid-view-atoms';
import { dispatchAtom } from '../../atoms/label-store-dispatch/dispatch';
export const VideoGridView = () => {
  const isGridViewEnabled = useAtomValue(isGridViewEnabledAtom);
  const canEnableGridView = useAtomValue(canEnableGridViewAtom);
  const dispatch = useSetAtom(dispatchAtom);
  const {
    featureFlags,
    isLoading
  } = useFeatureFlag(FEATURE_FLAGS.VIDEO_GRID);
  const handleVideoGridViewSelect = useCallback(() => {
    dispatch(toggleVideoGridAction());
  }, [dispatch]);
  const videoGridFeatureFlag = featureFlags?.[FEATURE_FLAGS.VIDEO_GRID];
  if (!canEnableGridView || isLoading || !videoGridFeatureFlag) {
    return null;
  }
  if ('error' in videoGridFeatureFlag) {
    console.error(videoGridFeatureFlag.error);
    return null;
  }
  if (!videoGridFeatureFlag.enabled) {
    return null;
  }
  return <ToolbarButton title="Video Grid View" isSelected={isGridViewEnabled} onClick={handleVideoGridViewSelect}>
      <DotGrid title="Video Grid View" />
    </ToolbarButton>;
};